var render, staticRenderFns
import script from "./ProviderIcon.vue?vue&type=script&lang=tsx&"
export * from "./ProviderIcon.vue?vue&type=script&lang=tsx&"
import style0 from "./ProviderIcon.vue?vue&type=style&index=0&id=106e28e2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports